import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const LANDCOVER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.LandCover.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.LandCover.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const LANDCOVER_CONFIG = {
  entityName: 'LandCover',
  localizationKey: 'Planning::Entity.LandCover',
  fields: LANDCOVER_FIELDS,
  permission: 'PlanningEnvironment.LandCovers',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
